const availableErrors = {
    required: { textFnc: () => 'This field is required.' },
    email: { textFnc: () => 'Email address is incorrect.' },
    alphaWithSpaces: {
        textFnc: () => `Field must contain only characters.`,
    },
    numeric: {
        textFnc: () => `Field must be numeric.`,
    },
    maxLength: {
        textFnc: (max) => `Field must have maximum ${max} letters.`,
        valueKey: 'max',
    },
    minLength: {
        textFnc: (min) => `Field must have minimum ${min} letters.`,
        valueKey: 'min',
    },
};
export default {
    functional: true,
    props: {
        field: {
            type: Object,
        },
    },
    render(createElement, { props }) {
        const params = props.field.$params;
        if (!params) {
            return createElement();
        }
        const errors = [];
        Object.keys(availableErrors).forEach((errorKey) => {
            const error = availableErrors[errorKey];
            if (params[errorKey] && !props.field[errorKey]) {
                let validationParam = null;
                if (error.valueKey) {
                    validationParam = params[errorKey][error.valueKey];
                }
                const text = error.textFnc(validationParam);
                errors.push(text);
            }
        });
        return createElement('b-form-invalid-feedback', errors[0]);
    },
};
